import { EditMajorV2EventPage } from "./EditMajorV2EventPage";

export default EditMajorV2EventPage;
